const roleRouter = [
    {
        path:'',
        name:'role-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/role/index.vue'),
        children:[
            {
                path:'',
                name:'role-empty',
                component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                props: { message: '請點選左側列表檢視角色 或 點選新增角色' }
            },
            {
                path:'create',
                name:'role-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/role/create.vue')
            },
            {
                path:'detail/:id',
                name:'role-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/role/detail.vue')
            },
            {
                path:'edit/:id',
                name:'role-edit',
                component: () => import(/* webpackChunkName: "about" */ '../views/role/edit.vue')
            },
        ]
    },
  ]
  export default roleRouter

  